
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";

interface FilterButtonsProps {
  showCompleted: boolean;
  setShowCompleted: (show: boolean) => void;
}

export const FilterButtons = ({ showCompleted, setShowCompleted }: FilterButtonsProps) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="flex w-full gap-2 sm:gap-4" data-tour="filter-buttons">
      <Button
        variant="outline"
        className={`flex-1 rounded-[15px] h-9 font-medium transition-all ${
          isMobile ? 'px-2 text-sm' : 'px-24 text-base'
        } py-0.5 ${
          !showCompleted
            ? "bg-gray-100 text-gray-800 border-gray-300"
            : "bg-transparent hover:bg-gray-50"
        }`}
        onClick={() => setShowCompleted(false)}
      >
        Current Habits
      </Button>
      <Button
        variant="outline"
        className={`flex-1 rounded-[15px] h-9 font-medium transition-all ${
          isMobile ? 'px-2 text-sm' : 'px-24 text-base'
        } py-0.5 ${
          showCompleted
            ? "bg-gray-100 text-gray-800 border-gray-300"
            : "bg-transparent hover:bg-gray-50"
        }`}
        onClick={() => setShowCompleted(true)}
      >
        Finished Habits
      </Button>
    </div>
  );
};
